import { render, staticRenderFns } from "./indicator.vue?vue&type=template&id=0f9fd0f9&scoped=true&"
import script from "./indicator.vue?vue&type=script&lang=js&"
export * from "./indicator.vue?vue&type=script&lang=js&"
import style0 from "./indicator.vue?vue&type=style&index=0&id=0f9fd0f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fd0f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9fd0f9')) {
      api.createRecord('0f9fd0f9', component.options)
    } else {
      api.reload('0f9fd0f9', component.options)
    }
    module.hot.accept("./indicator.vue?vue&type=template&id=0f9fd0f9&scoped=true&", function () {
      api.rerender('0f9fd0f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chronic/components/indicator.vue"
export default component.exports